module.exports = __webpack_public_path__ + "img/18_48.9059301a.png";